@if (showMainRoute()) {
  <div class="company-profile">
    <h1>My Company Profile</h1>
    @if (companyInfo()) {
      {{ companyInfo()?.CompanyName }}
      <br />
      <span class="angular-with-newlines">{{ companyInfo()?.Address }}</span
      ><br />
      {{ companyInfo()?.ZipCity }}<br />
      {{ companyInfo()?.Country }}<br />
      {{ companyInfo()?.PhoneNumber }}
    }
    <div class="action-buttons">
      <a [routerLink]="[routesConst.edit]" mat-raised-button class="btn btn-default">Edit Company Profile</a>
    </div>
  </div>
}

<router-outlet (activate)="onActivate()" (deactivate)="onDeactivate()"></router-outlet>
